import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const AboutPreview = () => {
  return (
    <section className="relative py-32 bg-charcoal overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image Side */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <div className="relative rounded-3xl overflow-hidden aspect-[4/5]">
              <img
                src="https://public.readdy.ai/ai/img_res/b1a0b1f735e2e2e80436be9d58bbea62.jpg"
                alt="The Real Problem Company founder"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
            </div>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="absolute -bottom-8 -right-8 bg-gold text-black p-8 rounded-2xl shadow-2xl"
            >
              <div className="text-4xl font-black mb-1">25+</div>
              <div className="text-sm font-bold">Years Identifying Problems</div>
            </motion.div>
          </motion.div>

          {/* Content Side */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <span className="text-gold text-sm font-semibold tracking-widest uppercase mb-4 block">
              Who We Are
            </span>
            <h2 className="text-5xl md:text-6xl font-black text-white mb-6 leading-tight">
              Over-educated. Over-qualified. Completely over-committed to your problems.
            </h2>
            <p className="text-lg text-light-gray mb-6 leading-relaxed">
              Our team is drawn from a wide spectrum of industries — finance, medicine, law, 
              engineering, philosophy, and several fields that don't technically exist yet. 
              What unites us is a shared gift for taking any situation and making it 
              significantly more complicated than it needs to be.
            </p>
            <p className="text-lg text-light-gray mb-8 leading-relaxed">
              We don't just identify your problems. We over-think them, over-analyze them, 
              and — as a complimentary bonus — reliably produce new ones in the process. 
              Your problems will never run out. That is our solemn promise.
            </p>

            <div className="space-y-4 mb-10">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gold/10 flex-shrink-0">
                  <i className="ri-graduation-cap-line text-xl text-gold"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-white mb-1">
                    Dangerously Over-Educated
                  </h3>
                  <p className="text-light-gray">
                    Combined 340+ years of advanced degrees across disciplines that have no business being in the same room together
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gold/10 flex-shrink-0">
                  <i className="ri-add-circle-line text-xl text-gold"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-white mb-1">
                    Guaranteed Problem Growth
                  </h3>
                  <p className="text-light-gray">
                    Every engagement produces a minimum of 3 bonus problems at absolutely no additional charge
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gold/10 flex-shrink-0">
                  <i className="ri-brain-line text-xl text-gold"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-white mb-1">
                    World-Class Over-Thinking
                  </h3>
                  <p className="text-light-gray">
                    We apply a minimum of 14 analytical frameworks to every problem, ensuring it becomes unrecognizable by the end
                  </p>
                </div>
              </div>
            </div>

            <Link
              to="/about"
              className="inline-flex items-center gap-3 bg-gold text-black px-8 py-4 rounded-full text-base font-bold hover:bg-white transition-all duration-300 whitespace-nowrap"
            >
              Discover Our Legacy
              <i className="ri-arrow-right-line text-xl"></i>
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutPreview;